/**
 * @generated SignedSource<<9539aa0660a651b3b9cf0d539ddfef95>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentLinkCompletedPixCreditCard_charge$data = {
  readonly value: number | null | undefined;
  readonly valueWithDiscount: number | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useChargePaymentMethod_charge">;
  readonly " $fragmentType": "PaymentLinkCompletedPixCreditCard_charge";
};
export type PaymentLinkCompletedPixCreditCard_charge$key = {
  readonly " $data"?: PaymentLinkCompletedPixCreditCard_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkCompletedPixCreditCard_charge">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "valueWithDiscount",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "method",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentLinkCompletedPixCreditCard_charge",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useChargePaymentMethod_charge",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "availablePaymentMethods",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "paymentMethods",
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "brCode",
                  "storageKey": null
                },
                (v0/*: any*/),
                (v1/*: any*/)
              ],
              "type": "PaymentMethodPix",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/)
              ],
              "type": "PaymentMethodInstallments",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "installmentNumber",
                  "storageKey": null
                },
                (v0/*: any*/)
              ],
              "type": "PaymentMethodCreditCard",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "consentId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "authorizationUrl",
                  "storageKey": null
                }
              ],
              "type": "PaymentMethodITP",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "boletoBarcode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "boletoDigitable",
                  "storageKey": null
                },
                (v0/*: any*/)
              ],
              "type": "PaymentMethodBoleto",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Charge",
  "abstractKey": null
};
})();

(node as any).hash = "75b1ef591e7a90f306a671ed68a1ad3d";

export default node;
